import { StarFilledIcon } from "@radix-ui/react-icons";
import { Flex } from "@radix-ui/themes";
import { useState } from "react";

const MAX_STARS = 5;

type RatingProps = {
  value: number;
  onChange?: (value: number) => void;
};

export function Rating({ value, onChange }: RatingProps) {
  const [hoverValue, setHoverValue] = useState<number | null>(null);
  const displayValue = hoverValue ?? value;

  return (
    <Flex>
      {Array.from({ length: MAX_STARS }, (_, index) => {
        const starValue = index + 1;
        const isFilled = starValue <= displayValue;

        return (
          <StarFilledIcon
            key={index}
            width={32}
            height={24}
            style={{
              cursor: "pointer",
              color: "var(--accent-9)",
              opacity: isFilled ? 1 : 0.2,
              transition: "all 0.2s ease",
              paddingLeft: "4px",
              paddingRight: "4px",
              // avoid outline effect on mobile
              WebkitTapHighlightColor: "transparent",
            }}
            onClick={() => onChange?.(starValue)}
            onMouseEnter={() => setHoverValue(starValue)}
            onMouseLeave={() => setHoverValue(null)}
          />
        );
      })}
    </Flex>
  );
}
